//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import { Helmet } from 'react-helmet';
// import TagManager from 'react-gtm-module';

//components
import PermissoesLista from '../childrens/permissoesLista/.mixins';
import Modal_Remove from '../../../../../util/modal_remove/.mixins/Modal_Remove';
import Alerta from "../../../../../util/snackbars/.mixins/";

//controllers
import Permissao_controller from '../../../../../../controllers/permissao';
import Config from '../../../../../../controllers/config';
import Log from '../../../../../../controllers/log';

//childrens
import Columns from '../childrens/columns/.mixins';
import CustomSort from '../childrens/customSort/.mixins';
import CustomToolbar from '../childrens/customToolbar/.mixins';
import CustomToolbarSelect from '../childrens/customToolbarSelect/.mixins';
import DialogConfirmRemove from '../childrens/dialogConfirmRemove/.mixins';

export default class Permissoes extends Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();

        this.state = {
            title: 'Tipo de acesso',
            itens: [],
            itensTable: [],
            itensRemovidos: [],
            columns: [],
            isLoading: true,
            isError: false,
            error: null,
            onRowClick: null,
            customSort: CustomSort,
            customToolbar: null,
            customToolbarSelect: null,
            selectableRows: true,
            open: false,
            propsToolbarSelected: null
        };

        this.loadData = this.loadData.bind(this);
        this.setState = this.setState.bind(this);
        this.handleAdicionar = this.handleAdicionar.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        
    };

    handleClickOpen = () => {
        this.setState({open:true});
    };

    handleClose = () => {
        this.setState({open:false});
    };

    handleConfirm = () => {
        this.handleClose();
        var listSelectedIndex = this.state.propsToolbarSelected.selectedRows.data.map(e=>e.index);
        var listItens = this.state.propsToolbarSelected.displayData
            .filter(e=>!(listSelectedIndex).includes(e.dataIndex))
            .map(e=>e.data);
        var listRemovidos = this.state.propsToolbarSelected.displayData
            .filter(e=>(listSelectedIndex).includes(e.dataIndex))
            .map(e=>e.data);

        this.state.propsToolbarSelected.setSelectedRows([]);
        this.state.propsToolbarSelected.params.setState({
            itens: listItens,
            itensTable: listItens,
            itensRemovidos: listRemovidos
        });

        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        listRemovidos.forEach(element => {
            Permissao_controller.remove(token,element[1]);
        });
    };

    handleAdicionar() {
        this.props.router.push(this.props.route.path+'-ae');
    };

    UNSAFE_componentWillMount() {
        this.setState({
            customToolbar:() => <CustomToolbar {...this}/>,
            customToolbarSelect:(selectedRows, displayData, setSelectedRows) => 
                <CustomToolbarSelect
                    selectedRows={selectedRows}
                    displayData={displayData}
                    setSelectedRows={setSelectedRows}
                    params={this}
                />,
            onRowClick: (rowData, rowMeta) => {
                this.props.router.push('/permissao-ae/'+rowData[1]);
            },
        });
        this.loadData(null);
    };

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:permissoes',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-permissoes',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela Permissões!");
    };

    async loadData(filters) {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        try {
            
            const o_permissoes = await Permissao_controller.get(token,filters);
            const j_permissoes = JSON.parse(o_permissoes.body);
            
            if (o_permissoes.res.statusCode === 200) {
                
                //prepara dados para tabela
                var arrayItens = [];
                j_permissoes.itens.forEach(element => {
                    arrayItens.push([
                        element.dt_criacao,
                        element.id_md5,
                        element.descricao,
                        {id_md5:element.id_md5}
                    ]);
                });

                this.setState({
                    itens: arrayItens,
                    itensTable: arrayItens,
                    isLoading: false,
                    columns: Columns(this)
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:permissoes',
                //       eventAction: 'callback',
                //       eventLabel: 'sucesso:lista-permisssoes',
                //     }
                // });

            } else {
                if (
                    j_permissoes.status == false && 
                    j_permissoes.message && 
                    j_permissoes.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            this.child.current.retorno('Erro ao carregar dados!','error');
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:permissoes',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} - Permissão`}</title>
                </Helmet>
                <PermissoesLista {...this}/>
                <Modal_Remove  pai={this} ref={this.inputRef}/>
                <Alerta ref={this.child}/>
                <DialogConfirmRemove {...this}/>
            </div>
        );
    };

};